<template>
    <div class="dialog" :style="{ zIndex: new Date().getTime()-1741763154594 }">
        <div class="dialog_detail">
            <div style="text-align: center;"> <img class="kp" src="../../assets/lives/ld.png"></div>
            <div class="dialog_title">公 告</div>
            <div class="example"></div>
            <div class="dialog_content">
                {{ noticeMessage.text.message }}
            </div>
            <div @click="close" class="dialog_btn">知道了</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "applyControl",
    props: ['noticeMessage'],
    data() {
        return {

        }
    },

    methods: {
        close() {
            this.$emit('close')
        }
    },
}
</script>
<style scoped>
.dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .6);

}

.dialog_detail {
    width: 327px;
    /* height: 308px; */
    background: #fff;
    padding: 11px;
    position: relative;
    border-radius: 18px;
}

.example {
    position: absolute;
    left: 40px;
    top: 17px;
    background-color: #FFF0EE;
    /* background-image: radial-gradient(circle, #FFF0EE, #FF3232); */
    border-radius: 45%;
    width: 54px;
    height: 33px;
    box-shadow: 0px 2px 99px 0px #FF3232;

}

.kp {
    width: 90px;
    animation: shake 1s infinite;
    transition: transform 0.2s ease-in-out;
}

/* 定义关键帧动画，来模拟铃铛摇动的过程 */
@keyframes shake {
    0% {
        transform: rotate(0deg);
        /* 初始状态，不旋转 */
    }

    25% {
        transform: rotate(10deg);
        /* 向一个方向旋转一定角度 */
    }

    50% {
        transform: rotate(-10deg);
        /* 向另一个方向旋转一定角度，模拟来回摆动 */
    }

    75% {
        transform: rotate(5deg);
    }

    100% {
        transform: rotate(0deg);
        /* 回到初始位置 */
    }
}

.dialog_title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    font-weight: bold;
}

.dialog_content {
    color: #343434;
    font-size: 14px;
    text-align: justify;
    min-height: 145px;
    padding: 8px 10px;
    padding-bottom: 53px;
    word-break: break-all;
    line-height: 20px;
}

.dialog_btn {
    background: #FBD586;
    color: #572E18;
    border-radius: 30px;
    font-weight: bold;

}
</style>